@if (showForm$ | async) {
  <form [formGroup]="form" class="row col-12 gx-2">
    <div class="col-6">
      <input
        type="number"
        formControlName="amount"
        class="form-control form-control-sm"
        [min]="form.get('timeUnit')?.value?.min"
        [max]="form.get('timeUnit')?.value?.max"
        placeholder="amount"
        [class.is-invalid]="form.dirty && !form.valid" />
    </div>
    <div class="col-6">
      <select
        type="text"
        class="form-select form-select-sm"
        name="filterType"
        placeholder="Select Field"
        formControlName="timeUnit">
        @for (option of options$ | async; track option) {
          <option [ngValue]="option.value">{{ option.label }}</option>
        }
      </select>
    </div>
  </form>
}
